import { combineReducers } from 'redux';
import {
  SET_LOGO_ELEMENT_WIDTH,
  SET_LOGO_ELEMENT_HEIGHT,
  SET_LOGO_ELEMENT_LINK_HOMEPAGE,
  SET_LOGO_ELEMENT_MARGIN,
  SET_LOGO_ELEMENT_PADDING,
} from '../actions/action-names';

const width = (state = '', action) => {
  switch (action.type) {
    case SET_LOGO_ELEMENT_WIDTH:
      return action.value;
    default:
      return state;
  }
};

const height = (state = '', action) => {
  switch (action.type) {
    case SET_LOGO_ELEMENT_HEIGHT:
      return action.value;
    default:
      return state;
  }
};

const linkHomepage = (state = '', action) => {
  switch (action.type) {
    case SET_LOGO_ELEMENT_LINK_HOMEPAGE:
      return action.value;
    default:
      return state;
  }
};

const margin = (state = '', action) => {
  switch (action.type) {
    case SET_LOGO_ELEMENT_MARGIN:
      return action.value;
    default:
      return state;
  }
};

const padding = (state = '', action) => {
  switch (action.type) {
    case SET_LOGO_ELEMENT_PADDING:
      return action.value;
    default:
      return state;
  }
};

export default combineReducers({
  width,
  height,
  linkHomepage,
  margin,
  padding,
});


// WEBPACK FOOTER //
// ./app/header-builder/reducers/logo-element-options-reducers.js